module.exports = __webpack_public_path__ + "static/media/hp_ex_finance.a546400e.jpg";